<template>
    <div>
      <Head title="Payments" />
      <h1 class="mb-8 text-3xl font-bold"> 
        Payments
      </h1>
      <div class="flex items-center justify-between mb-6">
        <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
      </div>
      <div class="flex items-center justify-between mb-6">
        <a
          v-if="(order_payments.data.length > 0 && url())"
          class="btn-orange px-3 py-2 text-xs cursor-pointer"
          :href="`/payments/downloads${url()}`"
          download
          target="__blank"
        >
          <span>Download</span>
        </a>
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-3 pt-3 px-3 border border-dark">CustomerRef</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">PaymentMethodRef</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">TxnDate	Payment</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">RefNumber</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">ApplyToInvoiceRef</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">TotalAmount	Invoice</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">PaymentAmount</th>
                </tr>
                <tr v-for="listp in order_payments.data" :key="listp.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
                    <td class="border-t border border-dark">
                        <span class="flex items-center px-3 py-3 focus:text-orange-500">
                        {{ listp.channel_name }}
                        </span>
                    </td>
                    <td class="border-t border border-dark">
                      <span class="flex items-center px-3 py-3 focus:text-orange-500">
                        {{ listp.payment_mode }}
                        </span>
                    </td>
                    <td class="border-t border border-dark">
                      <span class="flex items-center px-3 py-3 focus:text-orange-500">
                        {{ listp.payment_date }}
                      </span>
                    </td>
                    <td class="border-t border border-dark" 
                      style="word-wrap: break-word !important; word-break: break-all !important; white-space: normal !important; width: 30%;"
                    >
                      <span class="flex items-center px-3 py-3 focus:text-orange-500">
                        {{ listp.payment_reference }}
                        </span>
                    </td>
                    <td class="border-t border border-dark">
                      <span class="flex items-center px-3 py-3 focus:text-orange-500">
                        {{ listp.invoice_number }}
                        </span>
                    </td>
                    <td class="border-t border border-dark">
                      <span class="flex items-center px-3 py-3 focus:text-orange-500 flex items-end px-3 items-end justify-end">
                        {{ listp.invoice_amount }}
                        </span>
                    </td>
                    <td class="border-t border border-dark">
                      <span class="flex items-center px-3 py-3 focus:text-orange-500 flex items-end px-3 items-end justify-end">
                        {{ listp.payment_amount }}
                      </span>
                    </td>
                </tr>
                <tr v-if="order_payments.data.length === 0">
                    <td class="px-3 py-3 border-t border border-dark" colspan="6">No data found</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="order_payments.links" />
    </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'
import LoadingButton from '@/Shared/LoadingButton'
import mapValues from 'lodash/mapValues'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchWithDateRange,
    DateRange,
    Pagination,
    LoadingButton
  },
  layout: Layout,
  props: {
    filters: Object,
    order_payments: Object,
  },
  data() {
    return {
      search: {
        dateValue: this.filters.dateValue,
        search: this.filters.search,
      },
    }
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/payments', pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    url() {
      let query = '';
      if (this.search.dateValue) {
        query += `dateValue=${this.search.dateValue}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
  },
}
</script>